@if (extensionPagingGroup) {
  @if (extensionPagingGroup.extensionPagingGroupExtension?.name) {
    <h5>Name</h5>
    <div class="extension-detail-item">
      {{ extensionPagingGroup.extensionPagingGroupExtension.name }}
    </div>
  }
  @if (extensionPagingGroup.pagingGroupMembersConnection?.items?.length > 0) {
    <h5>Direct Members</h5>
    @for (member of extensionPagingGroup.pagingGroupMembersConnection.items; track member) {
      <div>
        <ndt-extension-detail-link [extension]="member.extension"></ndt-extension-detail-link>
      </div>
    }
  }
  @if (extensionPagingGroup.pagingGroupExtensionGroupsConnection?.items?.length > 0) {
    <h5>Extension Group Members</h5>
    @for (group of extensionPagingGroup.pagingGroupExtensionGroupsConnection.items; track group) {
      <ndt-extension-group-detail-link [extensionGroup]="group.extensionGroup"></ndt-extension-group-detail-link>
    }
  }
}
